module.exports = __webpack_public_path__ + "img/logo_redur.ea4d2401.png";